import type { SVGProps } from 'react'

interface RegenerationTreeIconProps extends SVGProps<SVGSVGElement> {}

export function RegenerationTreeIcon(props: RegenerationTreeIconProps) {
  return (
    <svg
      viewBox="0 0 33 40"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path
        d="M13.3895 39.2633V30.1081C12.4082 30.4734 11.3644 30.6668 10.2579 30.6668C5.0386 30.6668 0.863159 26.3686 0.863159 20.9958C0.863159 18.2664 1.90702 15.8164 3.70246 14.0541C3.22228 12.8936 2.95088 11.6041 2.95088 10.2502C2.95088 4.87735 7.12632 0.579102 12.3456 0.579102C15.6025 0.579102 18.4835 2.2984 20.1746 4.87735H20.6965C22.2044 4.87735 23.6975 5.18309 25.0906 5.7771C26.4838 6.37112 27.7496 7.24179 28.8158 8.3394C29.8821 9.437 30.7279 10.74 31.3049 12.1741C31.8819 13.6082 32.179 15.1453 32.179 16.6975C32.179 18.2498 31.8819 19.7868 31.3049 21.2209C30.7279 22.655 29.8821 23.958 28.8158 25.0557C27.7496 26.1533 26.4838 27.0239 25.0906 27.6179C23.6975 28.212 22.2044 28.5177 20.6965 28.5177C19.6526 28.5177 18.6088 28.3673 17.5649 28.0664V39.2633H13.3895Z"
        fill="white"
      />
    </svg>
  )
}
